import { ViewController, OddsFrameView, Matchday, ModelUpdateEvent, DataReceiveEvent, SelectionUpdateEvent,
         ChannelSwitchEvent } from "@gaming/srvg-classes-core";

export class OddsFrameViewController extends ViewController {
    oddsFrame: OddsFrameView;
    channel: number;
    matchIds: number[];
    currentMatchday: Matchday;

    constructor( options ) {
        options = options || {};
        options.view = options.oddsFrame || null;
        super( options );
        this.oddsFrame = options.oddsFrame || null;
        this.matchIds = null;
        this.currentMatchday = null;
        this.channel = options.channel || 0;
    }

    refreshFrame() {
        if( ! this.currentMatchday ) {
            return;
        }
        if( ! this.matchIds ) {
            return;
        }
        if( typeof( this.oddsFrame.source() ) === 'undefined' ) {
            if( srvg.url.shopOddsIframeUrl !== null && srvg.url.shopOddsIframeUrl !== '' ) {
                // TODO get url from customer integration
                var src = srvg.url.shopOddsIframeUrl;
                if( ! src.match('\\?') ) {
                    src += '?';
                }
                else {
                    src += '&';
                }
                src += 'seasonid=' + this.currentMatchday.getSeason().nr;
                src += '&';
                src += 'matchday=' + this.currentMatchday.nr;
                src += '&';
                src += 'videomatchid=' + this.matchIds[this.channel];
                src += '&';
                src += 'odds_frames=' + srvg.numberOfMatchdayFrames;
                this.oddsFrame.setSource( src );
            }
            else {
                this.oddsFrame.setSource( '' );
            }
        }
        else {
            try {
                var frame = $(this.view.selector).get(0);
                if (!frame) {
                    return;
                }
                var frameWindow = frame['contentWindow'];
                if (frameWindow && typeof frameWindow['setVblMatchday'] === 'function') {
                    frameWindow['setVblMatchday']({
                        "season_no": this.currentMatchday.getSeason().id,
                        "season_name": this.currentMatchday.getSeason().nr,
                        "match_day": this.currentMatchday.nr,
                        "videomatchid": this.matchIds[this.channel]
                    });
                }
                else {
                    //srvg.debug.console('tried to set selected matchday, but no iframe function "setVblMatchday" found in IFrame ' + this.view.selector );
                }
            } catch (err) {
                //srvg.debug.console('tried to set selected matchday, but an error occured while accessing IFrame ' + this.view.selector);
                //srvg.debug.console( err )
            }
        }
    }

    // ************************** Event handlers **************************

    handleModelUpdateEvent( event:ModelUpdateEvent, provider ) {
        if( event.propertyName == 'selectedMatchday' ) {
            this.currentMatchday = event.propertyValue;
            this.refreshFrame();
        }
    }

    handleDataReceiveEvent( event:DataReceiveEvent, provider ) {
        if( provider == app.matchIdsFeedController ) {
            this.matchIds = event.data.match_ids;
            this.refreshFrame();
        }
    }

    handleSelectionUpdateEvent( event: SelectionUpdateEvent, provider ) {
        if( event.items.length ) {
            if (srvg.url.shopOddsIframeUrl === null || srvg.url.shopOddsIframeUrl === '') {
                return;
            }
            try {
                var frame = $(this.view.selector).get(0);
                if (!frame) {
                    return;
                }
                var frameWindow = frame['contentWindow'];
                if (frameWindow && typeof frameWindow['setVblCombo'] === 'function') {
                    frameWindow['setVblCombo'](event.items[0].oddsData);
                }
                else {
                    //srvg.debug.console('tried to set selected combo odd, but no iframe function "setVblCombo" found in IFrame ' + this.view.selector);
                }
            } catch (err) {
                //srvg.debug.console('tried to set selected combo odd, but an error occured while accessing IFrame ' + this.view.selector);
                //srvg.debug.console( err )
            }
        }
        else {
            if (srvg.url.shopOddsIframeUrl === null || srvg.url.shopOddsIframeUrl === '') {
                return;
            }
            try {
                var frame = $(this.view.selector).get(0);
                if (!frame) {
                    return;
                }
                var frameWindow = frame['contentWindow'];
                if (frameWindow && typeof frameWindow['clearVblCombo'] === 'function') {
                    frameWindow['clearVblCombo']();
                }
                else {
                    //srvg.debug.console('tried to clear combo odd, but no iframe function "clearVblCombo" found in IFrame ' + this.view.selector);
                }
            } catch (err) {
                //srvg.debug.console('tried to clear combo odd, but an error occured while accessing IFrame ' + this.view.selector);
                //srvg.debug.console( err )
            }
        }
    }

    handleChannelSwitchEvent(event:ChannelSwitchEvent, provider) {
        this.channel = event.newChannel;
        this.refreshFrame();
    }
}